<template>
  <div id="product-documents-ipr-dynamic-create">

    <dynamic-form
      @type="type = $event"
      v-if="model"
      v-model="model"
      ref="form"
      :forms="formReferences"
      :apiModel="apiModel"
      :ProductCompanyType="ProductCompanyType"
      :ProductCompanyType_FK="ProductCompanyType_FK"
    />
    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              :disabled="loading"
              @click="$router.push({ name: `${ProductCompanyType}.dynamic-ipr.list` })"
              class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              :disabled="loading"
              @click="create()"
              class="my-4"
              color="light"
          >
            Upload
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import DynamicForm from "@/views/pages/product-documents-ipr/dynamic/DynamicForm";
import ProductDocumentCreateMixin from "@/components/mixins/ProductDocumentCreateMixin";
import IprProductCompanyTypeMixin from "@/components/mixins/IprProductCompanyTypeMixin";

export default {
  name: "DynamicIprCreate",
  components: {
    DynamicForm,
  },
  mixins: [ProductDocumentCreateMixin, IprProductCompanyTypeMixin],
  data() {
    return {
      apiModel: this.companyTypeApiModel('productDynamicIpr'),
      type: '',
    };
  },
};
</script>

<style scoped>

</style>
